export const fetchWertSession = async (options) => {
  const res = await fetch(`/api/wert-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
  })
  return res.json()
}
